import { useEffect, useState } from "react"
import QuotesStarter from "../components/QuotesStarter"
import CreateQuote from "../components/CreateQuote"
import QuotesList from "../components/QuotesList"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"
import "./css/Quotes.css"
import { SpinnerCircular } from "spinners-react"

const Quotes = () => {
    const [createQuote, setCreateQuote] = useState(false)
    const [quotesList, setQuotesList] = useState([])
    const [loading, setLoading] = useState(true)

    const token = localStorage.getItem("_crm__token")

    const fetchQuotes = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/quotes-list`, { token })

        setLoading(false)
        
        if (data.success) {
            setQuotesList(data.quotes)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchQuotes()
    }, [])

    if (createQuote) {
        return <CreateQuote setCreateQuote={setCreateQuote} />
    }

    if (loading) {
        return (
            <div className="_5dut">
                <SpinnerCircular size="60" color="#3b70ad" />
            </div>
        )
    }

    if (quotesList.length) {
        return (
            <QuotesList quotesList={quotesList} setCreateQuote={setCreateQuote} />
        )
    }

    // New user - no quotes created
    return (
        <QuotesStarter setCreateQuote={setCreateQuote} />
    )
}

export default Quotes

